module.exports = __webpack_public_path__ + "static/media/cross.5f1304cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/cross.svg
// module id = 1070
// module chunks = 0